document.querySelectorAll('.product__accordion details').forEach((detail) => {
  const summary = detail.querySelector('summary');
  const content = detail.querySelector('.accordion__content');

  // Initial height
  content.style.height = detail.hasAttribute('open') ? content.scrollHeight + 'px' : '0';
  content.style.marginBottom = detail.hasAttribute('open') ? '10px' : '0';

  summary.addEventListener('click', (e) => {
    e.preventDefault(); // prevent default toggle

    if (!detail.hasAttribute('open')) {
      // Open
      detail.setAttribute('open', '');
      content.style.height = content.scrollHeight + 'px';
      content.style.marginBottom = '20px'; // add margin on open
      setTimeout(() => {
        content.style.height = 'auto';
      }, 300);
    } else {
      // Close
      content.style.marginBottom = '0'; // remove margin immediately on close
      content.style.height = content.scrollHeight + 'px'; // fix current height
      requestAnimationFrame(() => {
        content.style.height = '0';
      });
      setTimeout(() => {
        detail.removeAttribute('open'); // remove after animation
      }, 300);
    }
  });
});



$(document).ready(function() {
  
  if ($(window).width() > 751){
    
    $(document).on('click', '.template_collection_changes .facets-container .facets__form .facet-filters.a_custom_filter', function(event){
      event.preventDefault();
      $('.facets-container menu-drawer summary.mobile-facets__open-wrapper .mobile-facets__open ').hide();
      $('.facets-container menu-drawer').removeClass('medium-hide large-up-hide');
      $('.facets-container menu-drawer .mobile-facets__disclosure').addClass('menu-opening');
      $('.facets-container menu-drawer .mobile-facets__disclosure').attr('open', 'true');
    });
    
  }
  
});


setInterval(function() {
  const isOpen = $('.facets-container menu-drawer .mobile-facets__disclosure').hasClass('menu-opening');
  const zIndex = isOpen ? '2000' : '2';
  $('#main-collection-filters .facets-container').css('z-index', zIndex);
}, 100);
